module.exports = __webpack_public_path__ + "img/cart-flatbed-empty.c7948577.svg";